import { CostEnum } from "packages/libs/shared-models/src/Enum/cost-enum";


export class RootWiseCostModel{
    id: number;
   routeType: CostEnum;  
   fromKmrange: number;
   toKmrange: number;
    cost:number;
    vehicleType:string;
    criteria:string;
    agreeSlab:string;
    perKmsRate:string;
    extraHrs:string;
    localBattaBefAft:string;
    osbatta:string
    isActive: boolean;
    versionFlag: number;
    plantId?:number;
    plantName?:string;

    constructor(id: number,routeType: CostEnum,fromKmrange: number,toKmrange: number, cost:number,vehicleType:string,criteria:string,agreeSlab:string,perKmsRate:string,extraHrs:string,localBattaBefAft:string,osbatta:string,isActive: boolean,versionFlag: number,  plantId?:number,plantName?:string
    ){
        this.id =id
        this.routeType =routeType
        this.fromKmrange=fromKmrange
        this.toKmrange=toKmrange
        this.cost=cost
        this.vehicleType=vehicleType
        this.criteria=criteria
        this.agreeSlab=agreeSlab
        this.perKmsRate=perKmsRate
        this.extraHrs=extraHrs
        this.localBattaBefAft=localBattaBefAft
        this.osbatta=osbatta
        this.isActive = isActive
        this.versionFlag = versionFlag
        this.plantId = plantId
        this.plantName=plantName
    }
}